import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import React from "react";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import slaCamerasService from "../../../../services/reports/sla-cameras-service.js";
import {useQuery} from "@tanstack/react-query";
import Loader from "../../../../components/template/loader.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({filters, setFilters}) => {
  const handleSpecialInput = useGeneralInputSpecialCase(setFilters);

  const {data: pcls = [], isLoading} = useQuery({
    queryFn: slaCamerasService.getAllWithSmartcatpureLane,
    queryKey: ['pcls']
  })


  return(
    <>
      {isLoading && <Loader/>}
      <div className={`mb-2 ${minMenuHeight}`}>
        <form id="search-form" className="flex flex-col gap-6">
          <div>
            <InputDateTime
              id="date_start"
              label="Data inicial *"
              dateFormat="L"
              selected={filters.date_start}
              onChange={date => handleSpecialInput("date_start", date)}
            />
          </div>
          <div>
            <InputDateTime
              id="date_end"
              label="Data final *"
              dateFormat="L"
              selected={filters.date_end}
              onChange={date => handleSpecialInput("date_end", date)}
            />
          </div>
          <div>
            <SelectComponent
              id="pcl"
              label="Pontos de coleta *"
              options={pcls}
              isMulti
              value={pcls.filter(el => filters.pcl.includes(el.value))}
              onChange={selected => handleSpecialInput("pcl", selected?.map(el => el.value))}
            />
          </div>
          <div>
            <InputCheckbox
              id='searchDetails'
              label="Exibir detalhes"
              checked={filters.searchDetails}
              onChange={() => setFilters(prev => ({...prev, searchDetails: !prev.searchDetails}))}
            />
          </div>
        </form>
      </div>
    </>
  )
}

export default Filters;